import { Paths, PathValue } from "@mctypes/global.types";
import { Button, Paper, Stack, Title } from "@mantine/core";
import { HSpace, McInputNew, McTextAreaNew } from "../../../../../../../components";
import {
  IGKMaalingAvLufthastighetVedOperasjonssengResultater,
  IGKRapport,
} from "../../../../../../../mc-shared/reportSchemas/gkReportSchema";
import ReportDocxImageContainer from "../../../../ReportBoard/ReportDocxImageContainer";
const MaalingAvLufthastighetVedOperasjonsseng: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKMaalingAvLufthastighetVedOperasjonssengResultater;
}> = ({ data, onUpdateEditData }) => {
  const addNewRow = () => {
    const maaleresultaterArray = data.inndata.maaleresultater;
    maaleresultaterArray.push(null);
    onUpdateEditData(
      "testResultater.maalingAvLufthastighetVedOperasjonssengLAFTak.inndata.maaleresultater",
      maaleresultaterArray,
    );
    return maaleresultaterArray;
  };
  const removeLastRow = () => {
    const updatedMaaleresultater = data.inndata.maaleresultater;
    if (updatedMaaleresultater.length > 0) {
      updatedMaaleresultater.pop(); // Remove the last element
      onUpdateEditData(
        "testResultater.maalingAvLufthastighetVedOperasjonssengLAFTak.inndata.maaleresultater",
        updatedMaaleresultater,
      );
    }
  };
  const updateMaaleresultater = (resultat, i) => {
    const maaleresultater = [...data.inndata.maaleresultater];
    maaleresultater[i] = resultat;
    onUpdateEditData(
      "testResultater.maalingAvLufthastighetVedOperasjonssengLAFTak.inndata.maaleresultater",
      maaleresultater,
    );
  };
  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>Måling av lufthastighet ved operasjonsseng</Title>
        <div className="d-flex flex-column mt-2">
          <b>Måletiden er fem sekunder &#40;s&#41;:</b>
        </div>
        <div className="mt-2">
          <b>Legg til flere punkter ved behov:</b>
          <div className="d-flex">
            <Button color="green" onClick={addNewRow}>
              Legg til rad
            </Button>
            <HSpace />
            <Button variant="danger-filled" onClick={removeLastRow} disabled={data.inndata.maaleresultater.length < 1}>
              Fjern siste rad
            </Button>
          </div>
        </div>
        <div className="mt-4 d-flex flex-column">
          <b>Fyll inn måleresultater &#40;m/s&#41;:</b>
          {data.inndata.maaleresultater.map((a, i) => (
            <McInputNew
              className="mb-1 w-25"
              key={i}
              value={a}
              normalizeNumbers={true}
              type="text"
              onBlur={(e) => updateMaaleresultater(Number(e.target.value), i)}
            />
          ))}
        </div>
        <div className="mt-4">
          <ReportDocxImageContainer
            docxImageTag="maalingAvLufthastighetVedOperasjonssengLAFTak"
            title="Målepunkter i rommet"
          />
          <div className="w-50">
            <McTextAreaNew
              label="Kommentar:"
              value={data.inndata.kommentar}
              onChange={(e) =>
                onUpdateEditData(
                  "testResultater.maalingAvLufthastighetVedOperasjonssengLAFTak.inndata.kommentar",
                  e.target.value,
                )
              }
            />
          </div>
        </div>
      </Stack>
    </Paper>
  );
};
export default MaalingAvLufthastighetVedOperasjonsseng;